import { ComboStepConfig } from '../shared/combo-types'

export const PROPOSITO_ALMA_NAME = 'Propósito y Alma'

export const PROPOSITO_ALMA_PREAMBLE = {
    firstStepIntro:
        'Es la primera parte de un camino de propósito y alma (renacer del propósito → temporada actual del alma → conexión con tu yo futuro).',
    finalStepClosing:
        'cerrá el arco del combo mostrando cómo el despertar del propósito, la temporada actual del alma y el yo futuro forman un mismo camino de alineación con el propósito del alma.',
}

export const PROPOSITO_ALMA_STEPS: ComboStepConfig[] = [
    {
        step: 1,
        type: 'combo-proposito-renacer',
        title: 'Tirada del Renacer del Propósito - Gran Viaje del Alma',
        shortTitle: 'Renacer del Propósito',
        cardCount: 26,
        requiresPersonalityNumerology: true,
    },
    {
        step: 2,
        type: 'combo-proposito-temporada',
        title: 'Tirada de Temporada Actual del Alma',
        shortTitle: 'Temporada Actual del Alma',
    },
    {
        step: 3,
        type: 'combo-proposito-yo-futuro',
        title: 'Tirada de Conexión con tu Yo Futuro',
        shortTitle: 'Conexión con tu Yo Futuro',
    },
]

export const PROPOSITO_ALMA_TOTAL_STEPS = PROPOSITO_ALMA_STEPS.length
